import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface IframeState {
  connectionMade: boolean
  dataReceived: boolean
  chatExpanded?: boolean
}

const initialState: IframeState = {
  connectionMade: false,
  dataReceived: false,
  chatExpanded: false
}

export const iframeReducer = createSlice({
  name: 'iframe',
  initialState,
  reducers: {
    changeConnectionMade: (state, action: PayloadAction<boolean>) => {
      state.connectionMade = action.payload
    },
    changeDataReceived: (state, action: PayloadAction<boolean>) => {
      state.dataReceived = action.payload
    },
    changeChatExpanded: (state, action: PayloadAction<boolean>) => {
      state.chatExpanded = action.payload
    }
  }
})

export const { changeConnectionMade, changeDataReceived, changeChatExpanded } = iframeReducer.actions

export default iframeReducer.reducer
